<template>
    <el-container style="height: 100vh">
        <el-header>
            <div class="logo">
                <img src="./../assets/logo5.png" alt="" />
                <!-- <span>SwiftInt&nbsp;敏捷EDI</span> -->
              
            </div>
           
            <div class="avater">
                <el-dropdown>
                    <div class="user">
                        <el-avatar size="medium" :src="circleUrl"></el-avatar>
                        <span>{{userName}}</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="dialogVisible = true"
                            >修改密码</el-dropdown-item
                        >
                        <el-dropdown-item @click.native="logout"
                            >退出登录</el-dropdown-item
                        >
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </el-header>
        <el-main style="padding: 20px">
            <router-view></router-view>
        </el-main>
        <el-footer>
           <div style="line-height: 60px; font-size: 14px; color: #666; text-align: center">
               Power by YiSquare {{ new Date().getFullYear()}}
           </div>
        </el-footer>
        <el-dialog title="修改密码" :visible.sync="dialogVisible" width="400px" @opened="handleClose" :close-on-click-modal="false">
            <el-form
                :model="ruleForm"
                status-icon
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
            >
                <el-form-item label="原始密码" prop="age">
                    <el-input v-model.number="ruleForm.oriPass"  type="password"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="pass">
                    <el-input
                        type="password"
                        v-model="ruleForm.pass"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPass">
                    <el-input
                        type="password"
                        v-model="ruleForm.checkPass"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editPassword('ruleForm')"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </el-container>
</template>

<script>
export default {
    name: "LayerView",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入新密码"));
            } else {
                if (this.ruleForm.checkPass !== "") {
                    this.$refs.ruleForm.validateField("checkPass");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.ruleForm.pass) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            userName: localStorage.getItem('ediUsername'),
            // userName: 'Administrator',
            circleUrl:
                "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

            dialogVisible: false,

            ruleForm: {
                pass: "",
                checkPass: "",
                oriPass: "",
            },
            rules: {
                pass: [{ validator: validatePass, trigger: "blur" }],
                checkPass: [{ validator: validatePass2, trigger: "blur" }],
                oriPass: [
                    {
                        required: true,
                        message: "请输入原始密码",
                        trigger: "blur",
                    },
                ],
            },
        };
    },

    methods: {
        handleClose() {
            this.$refs.ruleForm.resetFields();
        },
        editPassword(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$http.post(`/user/update?username=${this.userName}&oldPassword=${this.ruleForm.oriPass}&newPassword=${this.ruleForm.pass}`).then(res => {
                        if (res.code == 200) {
                            this.$notify({
                                title: '成功',
                                message: '修改成功',
                                type: 'success'
                            });

                            this.$refs[formName].resetFields();

                            this.$nextTick(() => {
                                this.dialogVisible = false
                                // localStorage.removeItem("ediToken");
                                this.$http.get('/logout')
                                this.$router.replace("/login");
                            })
                        } else {
                            this.$notify({
                                title: '失败',
                                message: '原始密码错误',
                                type: 'error'
                            });
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        logout() {
            this.$confirm("是否退出登录?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {

                this.$http.get('/logout')
                this.$router.replace("/login");
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./../assets/var.scss";
.el-header {
    background-color: $--color-primary;
    display: flex;
    align-items: center;
    justify-content: space-between;

    background-image: url("./../assets/explore.png");
    background-position: right;
    background-repeat: no-repeat;
    padding-left: 0;
    box-shadow: 0 0 10px 12px rgba(0, 0, 0, 0.13);
    .logo {
        padding: 0 0 0 20px;
        background-color: #fff;
        height: 100%;
        display: flex;
        img {
            margin-top: 8px;
            height: 46px;
            vertical-align: middle;
            margin-right: 15px;
        }

    }

    .avater {
        display: flex;
        align-items: center;
        .user {
            display: flex;
            align-items: center;
            i,
            span {
                color: #fff;
                margin-left: 5px;
            }
        }
    }
}
::v-deep .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 4px solid #2033b3;
}
::v-deep .el-menu-item.is-disabled { color: #ccc !important; opacity: 1}
</style>
